export default "__VITE_ASSET__DkGqsyzb__"